module.exports = __webpack_public_path__ + "img/luojisiwei.95d21f97.png";